export default {
  'app.network.offline':
    '現在オフラインです。一部の機能が利用できない場合があります',
  'app.error.chunk.title': 'ページの読み込みに失敗しました',
  'app.error.chunk.description.offline':
    'ネットワーク接続が切断されています。接続を確認してページを再読み込みしてください。',
  'app.error.chunk.description.online':
    'ページリソースの読み込みに失敗しました。ページを再読み込みしてください。',
  'app.error.render.title': 'エラーが発生しました',
  'app.error.render.description':
    '申し訳ありません、ページでエラーが発生しました。ページを再読み込みするか、ホームに戻ってください。',
  'app.error.retry': '再試行',
  'app.error.reload': 'ページを再読み込み',
  'app.error.home': 'ホームに戻る',
  'app.request.offline':
    'ネットワークに接続できません。接続を確認して再試行してください。',
};
